import { CustomButton } from 'components/ui'
import TextInput from 'components/ui/Forms/TextInput'
import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Clear'
import { useSearchTable } from 'context/SearchTableContext'
import cn from 'classnames'
const BuscadorCustom = ({ classnames, placeholder = 'Buscar por nombre.' }) => {
  const {
    handleOnSubmit,
    inputValue,
    handleOnChange,
    searchedValue,
    resetInfo,
  } = useSearchTable()

  return (
    <div className={cn('buscador-articulos-container', classnames)}>
      <form className="buscador-articulos-form" onSubmit={handleOnSubmit}>
        <TextInput
          placeholder={placeholder}
          value={inputValue}
          onChange={handleOnChange}
          containerStyles={{ width: '100%' }}
        />
        {searchedValue === '' && (
          <CustomButton
            type="submit"
            className="btn-secondary search-button-submit"
          >
            <SearchIcon className="search-icon-button" />
          </CustomButton>
        )}
      </form>
      {searchedValue !== '' && (
        <CustomButton
          className="btn-secondary search-button-submit"
          onClick={resetInfo}
        >
          <ClearIcon className="search-icon-button" />
        </CustomButton>
      )}
    </div>
  )
}

export default BuscadorCustom
